<div class="registrar-se-container">
    <mat-toolbar color="primary" class="toolbar">
        <app-back-button color="secondary"></app-back-button>
    </mat-toolbar>

    <mat-card class="card">
        <mat-card-header class="header">
            <mat-card-title class="title">{{ "REGISTER.TITLE" | translate }}</mat-card-title>
            <mat-card-subtitle class="subtitle">
                {{ "REGISTER.SUBTITLE" | translate }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <mat-vertical-stepper linear #stepper class="mat-primary stepper">
                <mat-step [stepControl]="nomeFormGroup">
                    <form [formGroup]="nomeFormGroup">
                        <ng-template matStepLabel>
                            {{ "REGISTER.NAME.TITLE" | translate }}
                        </ng-template>
                        <h5>
                            {{ "REGISTER.NAME.SUBTITLE" | translate }}
                        </h5>
                        <mat-form-field class="full-width">
                            <mat-label>{{ "REGISTER.NAME.INPUTS.NAME" | translate }}</mat-label>
                            <input
                                [id]="'input_registrar_Name'"
                                matInput
                                #nome
                                maxlength="50"
                                placeholder="ex, Obi Wan"
                                formControlName="nome"
                                required
                            />
                            <mat-hint align="end"> {{ nome.value.length }} / 50 </mat-hint>
                            <mat-error *ngIf="nomeFormGroup.controls['nome'].invalid">
                                {{ "REGISTER.NAME.MESSAGES.REQUIRED" | translate }}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="full-width">
                            <mat-label>{{ "REGISTER.NAME.INPUTS.LAST_NAME" | translate }}</mat-label>
                            <input
                                [id]="'input_registrar_LastName'"
                                matInput
                                #sobrenome
                                maxlength="50"
                                placeholder="ex, Kenobi"
                                formControlName="sobrenome"
                                required
                            />
                            <mat-hint align="end"> {{ sobrenome.value.length }} / 50 </mat-hint>
                            <mat-error *ngIf="nomeFormGroup.controls['sobrenome'].invalid">
                                {{ "REGISTER.NAME.MESSAGES.REQUIRED" | translate }}
                            </mat-error>
                        </mat-form-field>
                        <div class="stepperNavButtons">
                            <button
                                [id]="'button_registrar_NomeProximo'"
                                mat-stroked-button
                                color="primary"
                                matStepperNext
                            >
                                {{ "REGISTER.NAME.ACTIONS.NEXT" | translate }}
                            </button>
                        </div>
                    </form>
                </mat-step>

                <mat-step [stepControl]="emailFormGroup">
                    <form [formGroup]="emailFormGroup">
                        <ng-template matStepLabel>
                            {{ "REGISTER.EMAIL.TITLE" | translate }}
                        </ng-template>
                        <h5>
                            {{ "REGISTER.EMAIL.SUBTITLE" | translate }}
                        </h5>
                        <mat-form-field class="full-width">
                            <mat-label>Email</mat-label>
                            <input
                                [id]="'input_registrar_Email'"
                                matInput
                                maxlength="60"
                                placeholder="ex, ben.kenobi@gestionna.com"
                                formControlName="email"
                                email
                                #email
                                required
                                style="text-transform: lowercase"
                                (change)="trimEmail()"
                            />
                            <mat-hint align="end"> {{ email.value.length }} / 60 </mat-hint>
                            <mat-error *ngIf="emailFormGroup.invalid && emailFormGroup.hasError('required')">
                                {{ "REGISTER.EMAIL.MESSAGES.REQUIRED" | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailFormGroup.invalid && !emailFormGroup.hasError('required')">
                                {{ "REGISTER.EMAIL.MESSAGES.INVALID" | translate }}
                            </mat-error>
                        </mat-form-field>
                        <div class="stepperNavButtons">
                            <button
                                [id]="'button_registrar_EmailVoltar'"
                                mat-stroked-button
                                color="secondary"
                                matStepperPrevious
                            >
                                {{ "REGISTER.EMAIL.ACTIONS.BACK" | translate }}
                            </button>

                            <button
                                [id]="'button_registrar_EmailProximo'"
                                mat-stroked-button
                                color="primary"
                                matStepperNext
                            >
                                {{ "REGISTER.EMAIL.ACTIONS.NEXT" | translate }}
                            </button>
                        </div>
                    </form>
                </mat-step>

                <mat-step [stepControl]="appUserCustomFields.form" *ngIf="showUserCustomFieldsForm">
                    <ng-template matStepLabel>
                        {{ "REGISTER_INVITE.USER_CUSTOM_FIELDS.TITLE" | translate }}
                    </ng-template>
                    <h5>
                        {{ "REGISTER_INVITE.USER_CUSTOM_FIELDS.SUBTITLE" | translate }}
                    </h5>
                    <app-user-custom-fields
                        #appUserCustomFields
                        [fields]="userCustomFields$.value"
                        [editMode]="true"
                    ></app-user-custom-fields>
                    <div class="stepperNavButtons">
                        <button
                            [id]="'button_userCustomFields_Previous'"
                            mat-stroked-button
                            color="secondary"
                            matStepperPrevious
                        >
                            {{ "REGISTER_INVITE.USER_CUSTOM_FIELDS.ACTIONS.BACK" | translate }}
                        </button>

                        <button [id]="'button_userCustomFields_Next'" mat-stroked-button color="primary" matStepperNext>
                            {{ "REGISTER_INVITE.USER_CUSTOM_FIELDS.ACTIONS.NEXT" | translate }}
                        </button>
                    </div>
                </mat-step>

                <mat-step>
                    <form>
                        <ng-template matStepLabel>
                            {{ "REGISTER.CATEGORIES.TITLE" | translate }}
                        </ng-template>

                        <h5>
                            {{ "REGISTER.CATEGORIES.SUBTITLE" | translate }}
                        </h5>

                        <mat-chip-list [multiple]="true">
                            <mat-chip
                                *ngFor="let tag of tags"
                                (click)="selectMainTag(tag.id)"
                                [selected]="tag.selected"
                            >
                                {{ tag.nome }}
                            </mat-chip>
                        </mat-chip-list>

                        <mat-chip-list *ngFor="let tag of getSelectedTags()" style="margin-top: 25px" [multiple]="true">
                            <b style="width: 100%; text-align: center">
                                {{ tag.nome }}
                            </b>

                            <mat-chip
                                *ngFor="let child of tag.subCategorias"
                                (click)="selectChildrenTag(tag.id, child.id)"
                                [selected]="child.selected"
                                style="margin-top: 10px; margin-bottom: 15px"
                            >
                                {{ child.nome }}
                            </mat-chip>
                        </mat-chip-list>

                        <div class="stepperNavButtons">
                            <button
                                [id]="'button_registrar_CategoriasVoltar'"
                                mat-stroked-button
                                color="secondary"
                                matStepperPrevious
                            >
                                {{ "REGISTER.CATEGORIES.ACTIONS.BACK" | translate }}
                            </button>

                            <button
                                [id]="'button_registrar_CategoriasProximo'"
                                mat-stroked-button
                                color="primary"
                                matStepperNext
                            >
                                {{ "REGISTER.CATEGORIES.ACTIONS.NEXT" | translate }}
                            </button>
                        </div>
                    </form>
                </mat-step>

                <!-- as senhas serão os últimos steps -->
                <mat-step [stepControl]="appPasswordValidator.senhaForm">
                    <ng-template matStepLabel>
                        {{ "REGISTER.PASSWORD.TITLE" | translate }}
                    </ng-template>
                    <h5>
                        {{ "REGISTER.PASSWORD.SUBTITLE" | translate }}
                    </h5>

                    <app-password-validator
                        #appPasswordValidator
                        [passwordRegex]="getPasswordRegex()"
                        [passwordCustomRules]="getPasswordCustomRules()"
                        (validValue)="validPassword($event)"
                        (password)="password($event)"
                    ></app-password-validator>

                    <div class="stepperNavButtons">
                        <button
                            [id]="'button_registrar_SenhaVoltar'"
                            mat-stroked-button
                            color="secondary"
                            matStepperPrevious
                        >
                            {{ "REGISTER.PASSWORD.ACTIONS.BACK" | translate }}
                        </button>

                        <button
                            [id]="'button_registrar_SenhaProximo'"
                            mat-stroked-button
                            color="primary"
                            matStepperNext
                            [disabled]="!_validPassword"
                        >
                            {{ "REGISTER.PASSWORD.ACTIONS.NEXT" | translate }}
                        </button>
                    </div>
                </mat-step>

                <mat-step [stepControl]="termosUsoFormGroup">
                    <form [formGroup]="termosUsoFormGroup">
                        <ng-template matStepLabel>
                            {{ "REGISTER.TERMS_OF_USE.TITLE" | translate }}
                        </ng-template>

                        <button mat-stroked-button (click)="openTermsOfUseDialog()">
                            {{ "REGISTER.TERMS_OF_USE.SUBTITLE" | translate }}
                            <mat-icon>visibility</mat-icon>
                        </button>

                        <mat-slide-toggle
                            (change)="onChange($event, stepper)"
                            #toggleTermosUso
                            color="primary"
                            formControlName="aceitoTermos"
                            style="margin-top: 25px; display: flex; float: right"
                            [disabled]="!TermsOfUseClicked"
                        >
                            {{ "REGISTER.TERMS_OF_USE.INPUTS.TOGGLE" | translate }}
                        </mat-slide-toggle>
                    </form>
                </mat-step>

                <mat-step [stepControl]="politicaPrivacidadeFormGroup">
                    <form [formGroup]="politicaPrivacidadeFormGroup">
                        <ng-template matStepLabel>
                            {{ "REGISTER.PRIVACY_POLICY.TITLE" | translate }}
                        </ng-template>

                        <button mat-stroked-button (click)="openPrivacyPoliceDialog()">
                            {{ "REGISTER.PRIVACY_POLICY.SUBTITLE" | translate }}
                            <mat-icon>visibility</mat-icon>
                        </button>

                        <mat-slide-toggle
                            (change)="onChange($event, stepper)"
                            #togglePoliticaPrivacida
                            color="primary"
                            formControlName="concordoPoliticaPrivacidade"
                            style="margin-top: 25px; display: flex; float: right"
                            [disabled]="!privacyPolicyClicked"
                        >
                            {{ "REGISTER.PRIVACY_POLICY.INPUTS.TOGGLE" | translate }}
                        </mat-slide-toggle>
                    </form>
                </mat-step>

                <mat-step>
                    <ng-template matStepLabel>
                        {{ "REGISTER.DONE.TITLE" | translate }}
                    </ng-template>
                    <h5>
                        {{ "REGISTER.DONE.SUBTITLE" | translate }}
                    </h5>

                    <div [hidden]="!error" class="alert alert-warning">
                        {{ error }}
                    </div>
                    <div [hidden]="!errorApi" class="alert alert-warning">
                        {{ errorApi | json }}
                    </div>

                    <div [hidden]="!success" class="alert alert-info">
                        {{ success }}
                    </div>

                    <div class="stepperNavButtons">
                        <button
                            [id]="'button_registrar_FeitoVoltar'"
                            mat-stroked-button
                            color="secondary"
                            matStepperPrevious
                            *ngIf="!cadastrado"
                        >
                            {{ "REGISTER.DONE.ACTIONS.BACK" | translate }}
                        </button>

                        <button
                            [id]="'button_registrar_FeitoCadastrar'"
                            mat-flat-button
                            color="primary"
                            (click)="cadastrarUsuario()"
                            [disabled]="isLoading || !toggleTermosUso.checked"
                            [class.spinner]="isLoading"
                            *ngIf="!cadastrado"
                        >
                            {{ "REGISTER.DONE.ACTIONS.REGISTER" | translate }}
                        </button>

                        <button
                            [id]="'button_registrar_FeitoIniciar'"
                            mat-flat-button
                            color="primary"
                            (click)="login()"
                            [disabled]="isLoading || uploadingFiles"
                            *ngIf="cadastrado"
                            [class.spinner]="isLoading || uploadingFiles"
                        >
                            {{ "REGISTER.DONE.ACTIONS.BEGIN" | translate }}
                        </button>
                    </div>
                </mat-step>
            </mat-vertical-stepper>
        </mat-card-content>
    </mat-card>
</div>
